import { FULFILLMENT_TIME_DEFAULT } from './constants';

export const parseFulfillmentTime = (
  supportedFulfillmentTimestamps,
  fulfillmentTime,
  isAsapUnavailable = false,
) => {
  const fulfillmentTimeFallback = isAsapUnavailable
    ? supportedFulfillmentTimestamps[0]
    : FULFILLMENT_TIME_DEFAULT;

  if (!fulfillmentTime) {
    return fulfillmentTimeFallback;
  }

  const normalisedFulfillmentTime = fulfillmentTime.toString().toUpperCase();
  if (!supportedFulfillmentTimestamps.length) {
    // If we haven't got the exhaustive list of valid timestamps (i.e. on page load), do a basic regex test
    return /\d+/.test(normalisedFulfillmentTime)
      ? normalisedFulfillmentTime
      : fulfillmentTimeFallback;
  }

  return supportedFulfillmentTimestamps.includes(normalisedFulfillmentTime)
    ? normalisedFulfillmentTime
    : fulfillmentTimeFallback;
};

export const getFulfillmentTimeParam = (fulfillmentTime) =>
  // TODO: delivery_time => time or fulfillment_time when BE supports it
  fulfillmentTime === FULFILLMENT_TIME_DEFAULT ? null : `delivery_time=${fulfillmentTime}`;
